import { apiClient } from '@src/services/http-common'
import { LoginCredentials } from '@src/types/LoginCredentials'
import type { User } from '@src/types/user'
import type { MutationFunction, QueryFunction } from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
export interface JwtToken {
  jwt: string
}

export function signIn(data: JwtToken) {
  return apiClient.post<JwtToken>('/GenerateJwtToken', data)
}

export function getMockUsers() {
  return apiClient.get('/MockLogin')
}

export function postMockLogin(creds: LoginCredentials) {
  return apiClient.post<JwtToken>('/MockLogin', creds)
}

export const getUser: QueryFunction<User, [string]> = async () => {
  const response = await apiClient.get<User>('/MyProfile')
  return response.data
}

export function useGetUserById(userId: string | undefined) {
  const { isLoading, data, error } = useQuery({
    queryKey: [encodeURI(userId ?? '')],
    queryFn: getUser,
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: userId !== undefined,
  })

  return { isLoading, data, error }
}

const updateInformation: MutationFunction<User, User> = async (queryKey) => {
  const response = await apiClient.put('/MyProfile', queryKey)
  return response.data as User
}

export function useUpdateUser() {
  const { isPending, mutateAsync, reset } = useMutation({
    mutationFn: updateInformation,
  })

  return { isPending, mutateAsync, reset }
}
